import React, { useState, useEffect, useContext } from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";
import Uploader from "components/image-uploader/Uploader";
import BookingServices from "services/BookingServices";
import { notifyError, notifySuccess } from "utils/toast";
import { SidebarContext } from "context/SidebarContext";
import { FiX } from "react-icons/fi";

const Updatearrivalmodal = ({
  isOpen,
  onClose,
  client_id,
  guest_image,
  viewLabel,
  editLabel,
  actionLabel,
}) => {
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo") || "{}");

const employeeId = adminInfo?.id || adminInfo?.employee_id || null;
  const [guestImage, setGuestImage] = useState(null);
  const [isClientNotArrived, setIsClientNotArrived] = useState(false);
  const { setIsUpdate } = useContext(SidebarContext);

  const isViewMode = viewLabel === "View";
  const isEditMode = editLabel === "Edit";
  const isActionMode = actionLabel === "Action";

  useEffect(() => {
    if (isOpen) {
      // Reset image and status
      if (isActionMode) {
        setGuestImage(null); // show uploader only
        setIsClientNotArrived(false); // default to "Arrived"
      } else {
        setGuestImage(guest_image || null);
        setIsClientNotArrived(false);
      }
    }
  }, [isOpen, guest_image, isActionMode]);

  const handleImageUpload = (imagePath) => {
    setGuestImage(imagePath);
  };

  const handleCancelPrimeImage = () => {
    if (!isViewMode) {
      setGuestImage(null);
    }
  };

  const handleConfirm = async () => {
    try {
      const payloads = {
        guest_image: guestImage,
        is_client_not_arrived: isClientNotArrived,
        employee_id:employeeId
      };

      const response = await BookingServices.Updatearrivals(client_id, payloads);

      if (response.status === true) {
        notifySuccess(response.message);
        setIsUpdate(true);
      } else {
        notifyError(response.message);
        setIsUpdate(true);
      }

      onClose();
    } catch (error) {
      console.error("Error updating status:", error);
      notifyError("Error updating status.");
      onClose();
    }
  };

  return (
    <Modal
      className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
      isOpen={isOpen}
      onClose={() => {
        setGuestImage(null);
        setIsClientNotArrived(false);
        onClose();
      }}
    >
      <ModalBody className="custom-modal">
        <p className="font-semibold mb-4">Client Arrival Updation</p>

        {/* Image Preview or Uploader */}
        <div className="flex mt-4 justify-center">
          {guestImage ? (
            <div className="flex items-center relative">
              <img
                className="arrivalImg"
                src={process.env.REACT_APP_API_IMAGE_URL + guestImage}
                alt="guest"
              />
              {!isViewMode && (
                <FiX
                  className="absolute closeBtn"
                  size={20}
                  onClick={handleCancelPrimeImage}
                />
              )}
            </div>
          ) : (
            (isActionMode || isEditMode) && (
              <Uploader
                is_multiple={false}
                folder="guest_arrival"
                name_merge="client_img"
                no_of_image={1}
                onImageUpload={handleImageUpload}
                setImageUrl={setGuestImage}
              />
            )
          )}
        </div>

        {/* Radio buttons only in Edit mode */}
        {isEditMode && (
          <div className="flex mt-4 items-center">
            <label className="mr-4">
              <input
                type="radio"
                name="arrivalStatus"
                checked={!isClientNotArrived}
                onChange={() => setIsClientNotArrived(false)}
                className="mr-2"
              />
              Arrived
            </label>
            <label>
              <input
                type="radio"
                name="arrivalStatus"
                checked={isClientNotArrived}
                onChange={() => setIsClientNotArrived(true)}
                className="mr-2"
              />
              Not Arrived
            </label>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex justify-end mt-4 space-x-2">
          <Button
            layout="outline"
            onClick={() => {
              setGuestImage(null);
              setIsClientNotArrived(false);
              onClose();
            }}
            className="px-4 py-1 text-sm"
            style={{ minWidth: "auto" }}
          >
            Cancel
          </Button>

          {(isEditMode || isActionMode) && (
            <Button onClick={handleConfirm}>Update</Button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Updatearrivalmodal;
